'use client';
import { Village } from '@/services/types';
import Button from '../Button';
import { IDatePickerDictonary } from '@/dictionaries/components/datePicker/types';

type Props = {
  rangeValue: { start: Date | null; end: Date | null };
  onConfirmDates: () => void;
  clearDates: () => void;
  dict: IDatePickerDictonary;
  village?: Village;
  lang: string;
  showSummary?: boolean;
};

declare const window: Window & { dataLayer: Record<string, unknown>[] };

export default function DatePickerFooter({
  rangeValue,
  clearDates,
  onConfirmDates,
  dict,
  village,
  lang,
  showSummary,
}: Props) {
  function handleConfirmDates() {
    const atVillagePage = !!village;
    const atVillagesCatalogPage = !village && !!showSummary;

    if (atVillagePage) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'eventReservationFlow',
        eventCategory: 'reservation',
        eventAction: 'reservation_confirm',
        eventLabel: village.title,
        language: lang,
      });
    }
    if (atVillagesCatalogPage) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'eventBookingFlow',
        eventCategory: 'booking',
        eventAction: 'booking_confirm',
        eventLabel: 'VillaListing',
        language: lang,
      });
    }

    onConfirmDates();
  }

  return (
    <div className="flex md:py-[20px] md:justify-around">
      <Button
        disabled={rangeValue.start == null && rangeValue.end == null}
        onClick={clearDates}
        className="md:w-[12rem] hover:bg-white hover:text-[#977a0e] hover:text border-white cursor-pointer bg-white text-primary">
        {dict.clear}
        <span className="hidden md:block md:pl-2">{dict.dates}</span>
      </Button>

      <Button
        onClick={handleConfirmDates}
        className="w-full md:w-[12rem] hover:bg-primary hover:text-white transition-none whitespace-nowrap">
        {dict.confirm}
        <span className="hidden md:block md:pl-2">{dict.dates}</span>
      </Button>
    </div>
  );
}
